import React from "react";

import Header from "../../components/header/Header";
import Hero from "../../components/hero/Hero";
import Footer from "../../components/footer/Footer";
import LeagueLogos from "../../components/hero/LeagueLogos";
import HeroImage from "../../components/hero/HeroImage";
import UpToButton from "../../components/upToButton/UpToButtom";

interface BaseLayoutProps {
  children: React.ReactNode;
  leagueLogoActive?: boolean;
  isNavigation?: boolean;
  showUpToButton?: boolean;
  customHeroClass?: string;
}

function LiveTickerLayout({ children, leagueLogoActive = false, isNavigation = true, showUpToButton = true, customHeroClass  }: BaseLayoutProps) {

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    window.open("/", "_blank");
    window.close();
  };

  return (
    <>
      <Header isNavigation={isNavigation}>
        {/*<div className='logos-container' >*/}
        {/*  <img src={`${process.env.PUBLIC_URL}/assets/logos/signet-wasserball-frauen@2x.webp`}*/}
        {/*    alt='frauen wasserball liga logo'/>*/}
        {/*  <img src={`${process.env.PUBLIC_URL}/assets/logos/signet-wasserball-maenner@2x.webp`}*/}
        {/*    alt='männer wasserball liga logo'/>*/}
        {/*  <img src={`${process.env.PUBLIC_URL}/assets/logos/Wasserball_Bundesliga_schriftzug@2x.webp`}*/}
        {/*    alt='schriftzug wasserball liga'/>*/}
        {/*</div>*/}
        <a href="/" onClick={handleClick}>
          <img src={`${process.env.PUBLIC_URL}/assets/logos/logo-dieligadierockt@2x.webp`} alt="Wasserball Logo"
            width="200" height="80"/>
        </a>
      </Header>
      <Hero customClass={customHeroClass}>
        <>
          <HeroImage/>
          {leagueLogoActive &&
            <LeagueLogos/>
          }
        </>
      </Hero>
      <main>
        {children}
      </main>
      <Footer hidden={true}>
        {showUpToButton &&
          <UpToButton customClass={"small-up-to"}/>
        }
      </Footer>
    </>
  );
}

export default LiveTickerLayout;